export const tableDataStylesAlignMiddle = `tw-font-normal tw-p-3 !tw-align-middle tw-border-t`;

export const tableHeaderStyles = `tw-whitespace-nowrap tw-font-normal tw-text-sm tw-border-y tw-align-bottom`;

export const tableHeaderStylesNoBorder = `tw-font-normal tw-text-sm tw-align-bottom tw-p-3 tw-border-0`;

export const tableDataStylesAlignTop = `tw-font-normal tw-align-top tw-p-3 tw-border-t`;

export const tableDataTitlesClass = `tw-border-none tw-block tw-p-0 tw-leading-[2] tw-relative`;

export const tableDataStylesAfter = `tw-block tw-border-none tw-table tw-pl-[45%] tw-leading-[2] tw-relative tw-w-full after:tw-content-[attr(data-title)] after:tw-font-bold after:tw-table-cell after:tw-h-full after:tw-left-0 after:tw-m-auto after:tw-align-middle after:tw-whitespace-nowrap lg:tw-p-3 lg:tw-align-middle lg:tw-border-t`;
